import React from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { EditorColoreApiType, EditorErrorType, EditorImageType } from '@utils/types'
import { FormToggle, EditorColor, EditorImage } from '@components/atoms'
import EditorSidebarElement from '../EditorSidebarElement/EditorSidebarElement'
import styles from './EditorSidebarImage.module.sass'

interface Props {
  image?: EditorImageType
  selected?: boolean
  onRemove?: () => void
  onColorChange?: (id: number, o: string, n: string) => void
  onMonochromaticSwitch?: (id: number, v: boolean) => void
  onNoBackgroundSwitch?: (id: number, v: boolean) => void
  error?: EditorErrorType
  colorLimits?: {
    allowedColors?: EditorColoreApiType[]
    lockColorChange?: EditorColoreApiType | null
  }
  className?: string
}

const EditorSidebarImage = (props: Props) => {
  const {
    image,
    selected = false,
    onRemove,
    onColorChange,
    onMonochromaticSwitch,
    onNoBackgroundSwitch,
    error = undefined,
    colorLimits,
    className = '',
  } = props

  const t = useTrans()

  return image ? (
    <EditorSidebarElement
      selected={selected}
      variant={error ? error.variant : undefined}
      className={cn(styles.root, className)}
      onClose={onRemove}
    >
      <EditorImage image={image} error={error} onClose={onRemove} className={styles.image} />
      {image?.isVector && (
        <div className={styles.fields}>
          {image.hasBackground && (
            <FormToggle
              id={`editorsidebarimage_${image.id}_removebg`}
              label={t('Rimuovi background')}
              checked={image.noBackground}
              onChange={(e) => {
                onNoBackgroundSwitch(image.id, e.target.checked)
              }}
            />
          )}
          {image?.colori?.length > 1 && colorLimits?.allowedColors?.length === 0 && (
            <FormToggle
              id={`editorsidebarimage_${image.id}_monochrome`}
              label={t('Monocromatico')}
              checked={image.monochrome}
              onChange={(e) => {
                onMonochromaticSwitch(image.id, e.target.checked)
              }}
            />
          )}
          {!!image?.colori?.length && (
            <div className={styles.colors}>
              {image.colori.map((c) => (
                <EditorColor
                  key={c.id}
                  id={`editorsidebarimage_${image.id}_color_${c.id}`}
                  variant={c.variant}
                  value={c.value}
                  onChange={(colorValue) => {
                    onColorChange &&
                      onColorChange(image.id, c.originalValue || c.id || c.value, colorValue)
                  }}
                  allowedColors={colorLimits?.allowedColors}
                  lockColorChange={colorLimits?.lockColorChange}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </EditorSidebarElement>
  ) : (
    <></>
  )
}

export default EditorSidebarImage
